import createAuthLib from 'eight.js.auth';

import config from './../config';

const authConfig = {
  clientId: config.auth.clientId,
  clientSecret: config.auth.clientSecret,
  machineId: config.auth.machineId,
  machineSecret: config.auth.machineSecret,
  apiToAuthenticate: config.apiToAuthenticate,
  usersAPI: config.usersAPI,
  type: config.auth.type,
};

export const eightAuth = {
  ...createAuthLib(authConfig),
};
